import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch, useSelector } from 'react-redux';
import { selectors } from '../../containers/EditPage/reducer';
import * as Styled from './AnalogModal.styles';
import ModalWindow from '../ModalWindow';
import SearchBar from '../SearchBar/SearchBar';
import * as actionEdit from '../../containers/EditPage/actions';
import { ProductResponse } from '../../containers/EditPage/types';

import ProductCard from './components/ProductCard';
import { mapDataForProductInfoPrice } from '../../containers/EditPage/helpers';

interface AnalogModalProps {
  onClose: () => void;
  source: string;
  orderId: string;
  newProduct?: boolean;
}

const AnalogModal = ({
  onClose,
  source,
  orderId,
  newProduct,
}: AnalogModalProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState<string>('');

  const searchData = useSelector(selectors.postProductsSearchInPharmacyData);
  const searchLoading = useSelector(
    selectors.postProductsSearchInPharmacyLoading
  );

  const [isSuggestionOpen, setSuggestionOpen] = useState<boolean>(false);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchValue.length > 2) {
        dispatch(
          actionEdit.postProductsSearchInPharmacySaga.request({
            productName: searchValue,
            code: source,
            city: '',
            page: 1,
            limit: 50,
          })
        );
      }
      setSuggestionOpen(true);
    }, 200);
    return () => clearTimeout(delayDebounceFn);
  }, [dispatch, searchValue]);

  return (
    <ModalWindow onClose={onClose}>
      <Styled.AnalogModalContainer>
        <Styled.AnalogSearchContainer>
          <div className="description">
            {newProduct
              ? t('OrdersPage.OrderDetailedModal.ANALOG_MODAL.DESC_PRODUCT')
              : t('OrdersPage.OrderDetailedModal.ANALOG_MODAL.DESC')}
          </div>
          <div className="search-bar">
            <SearchBar
              value={searchValue}
              placeholder=""
              setValue={setSearchValue}
              onSearchClick={() => null}
            />
          </div>
        </Styled.AnalogSearchContainer>
        <Styled.AnalogSuggestion>
          {isSuggestionOpen && searchData && searchValue !== '' ? (
            <>
              {/* eslint-disable-nest-line */}
              {searchData?.length > 0 ? (
                <Styled.ProductsSearchItemContainer>
                  {searchData?.map((el: ProductResponse) => (
                    <ProductCard
                      data={mapDataForProductInfoPrice(
                        el,
                        searchData?.pricesAndQuantity
                      )}
                      key={el.sku}
                      newProduct={newProduct}
                      onClose={onClose}
                    />
                  ))}
                </Styled.ProductsSearchItemContainer>
              ) : (
                !searchData.length && (
                  <div className="search-no-results">
                    {t('OrderSearchModal.NO_RESULTS')}
                  </div>
                )
              )}
            </>
          ) : (
            searchLoading && (
              <div className="product-loading">
                <CircularProgress size={25} />
              </div>
            )
          )}
        </Styled.AnalogSuggestion>
      </Styled.AnalogModalContainer>
    </ModalWindow>
  );
};

export default AnalogModal;
